import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import DateRangeInput from '../../../base/components/guesser/date-range-input';
import { getBackofficeEnv } from '../../../services/util';

const BetDateRangeInput = props => {
  const {
    source, resource, label, ...rest
  } = props;
  const { BET_QUERY_SUPPORT_DAYS } = getBackofficeEnv();
  const today = moment()
    .add(1, 'days')
    .startOf('day');
  const yesterday = moment().subtract(1, 'days').startOf('day');

  const disabledDate = (current, dates) => {
    const startDate = dates[0] && moment(dates[0].format()).startOf('day');
    const endDate = dates[1] && moment(dates[1].format()).startOf('day');

    const currentDate = moment(current.format()).startOf('day');
    const now = moment();

    const numberOfDateLimit = 7;

    const tooLate = startDate
      ? currentDate.diff(startDate, 'days') >= numberOfDateLimit || currentDate.isAfter(now)
      : currentDate.isAfter(now);

    const tooEarly = endDate
      ? endDate.diff(currentDate, 'days') >= numberOfDateLimit
        || currentDate.isBefore(now.subtract(BET_QUERY_SUPPORT_DAYS, 'days'))
      : now.diff(currentDate, 'days') >= BET_QUERY_SUPPORT_DAYS && currentDate.isBefore(now);

    return !!tooEarly || !!tooLate;
  };

  return (
    <DateRangeInput
      entity="report"
      source={source}
      resource={resource}
      label={label}
      prefix
      clearable={false}
      dateRange={[yesterday, today]}
      disabledDate={disabledDate}
      ranges={[]}
      {...rest}
    />
  );
};

BetDateRangeInput.propTypes = {
  source: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
  label: PropTypes.string,
};

BetDateRangeInput.defaultProps = {
  label: '',
};

export default BetDateRangeInput;
